/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import autoBind from 'react-autobind'
import Cookies from 'cookies-js'
import R from 'ramda'
import { injectIntl } from 'react-intl'
import { withRouter, BrowserRouter, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { Snackbar, FontIcon } from 'material-ui'
import { white, red500, green500, deepOrange500 } from 'material-ui/styles/colors'

import {
  Grid,
  List,
  ListItem,
  ListSubheader,
  ListItemText,
  ListItemIcon,
  Typography,
  ListItemSecondaryAction,
  Button,
  IconButton,
  Popover,
  Chip,
  Tabs,
  Tab,
} from '@material-ui/core'

import {
  ArrowDropDown,
  Home,
  Event,
  Search,
  Lock,
  PowerSettingsNew,
  Security,
  AssignmentInd,
  Payment,
  Group,
  Message,
} from '@material-ui/icons'

import { red } from '@material-ui/core/colors/'

import * as constants from 'constants/Header'
import * as loginConstants from 'constants/Login'
import * as appConstants from 'constants/messages'
import * as actions from 'actions/Header'
import * as loginActions from 'actions/Login'
import * as alertActions from 'actions/Alert'

import logoImage from 'resources/images/logo_appartenances.svg'
import faqDownload from 'resources/files/faq_20240119.pdf'
import cguDownload from 'resources/files/cgu_20240531.pdf'
import faqSanteDownload from 'resources/files/faq_sante_20250610.pdf'
import faqSocialDownload from 'resources/files/faq_social_20250610.pdf'

import 'resources/styles/applicant/Header.css'

const NOTIF_COLORS = {
  [constants.NOTIF_ERROR]: red500,
  [constants.NOTIF_SUCCESS]: green500,
}

class Header extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      open: false,
      anchorEl: undefined,
      anchorElDownload: undefined,
      selectedPage: props.page,
      alert: undefined,
      showDownload: false,
    }
  }

  componentDidMount() {
    if(Cookies.get('alertLoaded') !== 'true') this.handleLoadAlert()
  }

  componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      this.setState({
        selectedPage: this.props.page
      })
    }
  }

  getOptionsByRole(role, prestationWebrtc, newPrestationAccess) {
    const isApplicant = role === loginConstants.APPLICANT_ROLE
    const user = this.getUserContext()
    const isStaff = user && user.isStaff

    return [
      {
        key:  0,
        text: constants.messages.ACCUEIL_MENU,
        link: '/dashboard/',
        show: true,
      },
      {
        key:  1,
        text: constants.messages.OFFER_MENU,
        link: '/prestation/',
        show: isApplicant,
      },
      {
        key:  2,
        text: constants.messages.HISTORY_MENU,
        link: '/history/',
        show: true,
      },
      {
        key:  3,
        text: constants.messages.VIDEO_PHONE_TUTORIAL_MENU,
        link: '/prestation/phone/',
        show: isApplicant && prestationWebrtc,
      },
      {
        key:  4,
        text: constants.messages.FAQ,
        link: undefined,
        show: isApplicant,
      },
      {
        key: 5,
        text: constants.messages.CHAT_MENU,
        link: '/chat/',
        show: isApplicant && isStaff
      }
    ]
  }

  getBannerOptions(role, isStaff) {
    if (isStaff)
      return {
        title: constants.messages.STAFF_TITLE,
        banner: 'HeaderStaffContainer',
      }

    switch (role) {
      case loginConstants.INTERPRETER_ROLE:
        return {
          title: constants.messages.INTERPRETER_TITLE,
          banner: 'HeaderInterpreterContainer',
        }
      case loginConstants.PAYING_CUSTOMER_ROLE:
        return {
          title: constants.messages.PAYING_CUSTOMER_TITLE,
          banner: 'HeaderPayingCustomerContainer',
        }
      case loginConstants.APPLICANT_ROLE:
        return {
          title: constants.messages.APPLICANT_TITLE,
          banner: 'HeaderApplicantContainer',
        }
      default:
        return {}
    }
  }

  handleLoadAlert() {
    if (!this.props.user.is_staff) return

    alertActions.getAlert()
      .then((result) => {
        Cookies.set('alertLoaded', 'true')
        this.setState({
          alert: result
        })
      })
  }

  handleOpenMenu(e) {
    this.handleLoadAlert()

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    })
  }

  handleRedirection(url, params) {
    this.props.history.push({pathname: url, ...params})
  }

  handlePageChange(event, index, options) {
    const option = options.find((option) => option.key === index)    
    if (!option) return

    if (option.text === constants.messages.FAQ) {
      this.setState({
        showDownload: true,
        anchorElDownload: event.currentTarget
      })

      return
    }    

    if (this.props.handlePageChange && option.text !== constants.messages.ACCUEIL_MENU) {
      this.props.handlePageChange(index)
    } else if (option.link) {
      this.props.history.push(option.link)
    }
  }

  handleLogout() {
    loginActions.logout()
      .then(() => {
        Cookies.set('isLogged', false)
        this.handleRedirection('/login/', {state: {from: this.props.location}})
      })
  }

  handleHistoryPage(data) {
    this.handleRedirection('/history/', {
      data: {
        ...data,
        page: 1
      }
    })
  }

  getUserContext() {
    return {
      name: this.props.user.identityName,
      role: this.props.user.role,
      isStaff: this.props.user.is_staff,
      paymentAccess: this.props.user.paymentAccess,
      applicantListAccess: this.props.user.applicantListAccess,
      newPrestationAccess: this.props.user.newPrestationAccess,
      prestationWebrtc: this.props.user.prestationWebrtc,
    }
  }

  getAccountMenuItems(isStaff, role, newPrestationAccess) {
    return [
      {
        onClick: () => this.handleRedirection('/dashboard/'),
        icon: Home,
        title: appConstants.messages.DASHBOARD_LABEL
      },
      {
        onClick: () => this.handleRedirection('/prestation/'),
        icon: Event,
        title: appConstants.messages.NEW_PRESTATION_LABEL,
        condition: (newPrestationAccess && role === loginConstants.APPLICANT_ROLE) || isStaff,
      },
      {
        onClick: () => this.handleRedirection('/history/'),
        icon: Search,
        title: appConstants.messages.HISTORY_LABEL,
      },
      {
        onClick: () => this.handleRedirection('/profile/'),
        icon: Lock,
        title: appConstants.messages.CHANGE_PASSWORD_LABEL,
      },
      {
        onClick: this.handleLogout,
        icon: PowerSettingsNew,
        title: appConstants.messages.LOGOUT,
      }
    ]
  }

  getAdministrationMenuItems(isStaff, paymentAccess, applicantListAccess) {
    const staffMenuItems = isStaff ? [
      {
        onClick: () => this.handleRedirection('/profile/', {showUserName: true}),
        icon: Security,
        title: appConstants.messages.CHANGE_USER_PASSWORD_LABEL,
      },
      {
        onClick: () => this.handleRedirection('/file/import/'),
        icon: AssignmentInd,
        title: appConstants.messages.FILE_LABEL,
      }
    ] : []

    const paymentMenuItems = paymentAccess ? [
      {
        onClick: () => this.handleRedirection('/file/payment/'),
        icon: Payment,
        title: appConstants.messages.PAYMENT_LABEL,
      }
    ] : []

    const applicantMenuItem = applicantListAccess ? [
      {
        onClick: () => this.handleRedirection('/applicant/list/'),
        icon: Group,
        title: appConstants.messages.APPLICANT_LABEL,
      }
    ] : []

    return [
      ...staffMenuItems,
      ...paymentMenuItems,
      ...applicantMenuItem,
    ]
  }

  getAlertsMenuItems(isStaff) {
    return isStaff
    ? [
        {
          params: {workflowSteps: ['invitation_sent']},
          path: ['nb_invitation_sent'],
          title: appConstants.messages.NOTIFICATION_INVITATION_SENT,
        },
        {
          params: {workflowSteps: ['failed'], date_gte: moment().format('YYYY-MM-DD HH:mm:ss')},
          path: ['nb_failed'],
          title: appConstants.messages.NOTIFICATION_FAILED,
        },
        {
          params: {workflowSteps: ['cancelled'], wkf_user_is_interpreter: 1, date_gte: moment().format('YYYY-MM-DD HH:mm:ss')},
          path: ['nb_interpreter_cancelled'],
          title: appConstants.messages.NOTIFICATION_CANCELLED,
        },
        {
          params: {has_proposals: true},
          path: ['nb_prestation_proposals'],
          title: appConstants.messages.NOTIFICATION_PROPOSALS,
        },
        {
          params: {workflowSteps: ['invitation_resent']},
          path: ['nb_prestation_resent'],
          title: appConstants.messages.NOTIFICATION_RESENT,
        }
      ]
    : []
  }

  renderMenuItems(items, sectionTitle) {
    if (!items || items.length===0) return

    return (
      <React.Fragment>
        <ListSubheader
          disableSticky={true}
        >
          {this.props.intl.formatMessage(sectionTitle)}
        </ListSubheader>

        {
          items
            .filter(({ condition = true }) => condition)
            .map(({ onClick, icon: Icon, title}) =>
                <ListItem
                  button
                  onClick={onClick}
                  key={title.id}
                >
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>

                  <ListItemText
                    primary={this.props.intl.formatMessage(title)}
                  />
                </ListItem>
            )
        }
      </React.Fragment>
    )
  }

  renderAlertsItems(items) {
    if (!items || items.length===0) return
  
    return (
      <React.Fragment>
        <ListSubheader
          disableSticky={true}
        >
          {this.props.intl.formatMessage(appConstants.messages.WARNING_LABEL)}
        </ListSubheader>

        {
          items
            .map(({params, path, title}) => 
              <ListItem 
                button
                onClick={() => this.handleHistoryPage(params)}
                key={title.id}
              >
                <Chip
                  label={R.path(path, this.state.alert) || 0}
                  style={styles.chip}
                />

                <ListItemText
                  primary={this.props.intl.formatMessage(title)}
                />
              </ListItem>
            )
        }
      </React.Fragment>
    )
  }

  getDocsMenuItems() {
    return [
      { link: faqDownload, title: appConstants.messages.FAQ },
      { link: cguDownload, title: appConstants.messages.CGU },
      { link: faqSanteDownload, title: appConstants.messages.FAQ_SANTE },
      { link: faqSocialDownload, title: appConstants.messages.FAQ_SOCIAL },
    ]
  }

  render () {
    const {
      name,
      role,
      isStaff,
      paymentAccess,
      applicantListAccess,
      newPrestationAccess,
      prestationWebrtc,
    } = this.getUserContext()

    const isMaintenancePeriod = moment().isSameOrBefore('2026-05-20', 'day')
    const maintenanceMessage = <React.Fragment>Notre application informatique sera indisponible <b>mercredi 20 mai</b> à partir de <b>18h</b> pour maintenance.</React.Fragment>
    const contactMessage1 = <b>Ligne de conseil et d’assistance : 021 353 53 53 - interpretariat@appartenances.ch</b>
    const contactMessage2 = <React.Fragment>du lundi au vendredi de 9h à 17h (sauf mardi de 10h à 17h).</React.Fragment>

    const accountMenuItems = this.getAccountMenuItems(isStaff, role, newPrestationAccess)
    const administrationMenuItems = this.getAdministrationMenuItems(isStaff, paymentAccess, applicantListAccess)
    const alertsMenuItems = this.getAlertsMenuItems(isStaff)
    const docsMenuItems = this.getDocsMenuItems()


    const tabsOptions = this.props.options.length
      ? this.props.options
      : this.getOptionsByRole(role, prestationWebrtc, newPrestationAccess)

    const {title, banner} = this.getBannerOptions(role, isStaff)

    return (
      <React.Fragment>
        <Grid container
          className={'Container HeaderContainer ' + banner}
        >
          <Grid item xs={8}
            style={{height: '50%'}}
          >
            <Grid container
              className='HeaderTitleContainer'
            >
              <Grid item xs={3}>
                <img src={logoImage} className='inline middle HeaderIcon' alt=""/>
              </Grid>

              <Grid item xs={9}
                className='HeaderTitleText'
              >
                <div className='HeaderTitleMainText'>
                  {title ? this.props.intl.formatMessage(title) : undefined}
                </div>

                { isMaintenancePeriod
                  ? <div style={styles.maintenance}>
                      <FontIcon
                        className='material-icons'
                        style={styles.icon}
                      >
                        info
                      </FontIcon>
                      <div>
                        { maintenanceMessage }
                      </div>
                    </div>
                  : <div style={styles.contact}>
                      {contactMessage1}

                      <div className='ContactMessageDetail'>
                        {contactMessage2}
                      </div>
                    </div>
                }
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4}
            style={{height: '50%'}}
          >
            <Grid container className='ProfileAvatarContainer'>
              <Button
                onClick={this.handleOpenMenu}
              >
                <Typography
                  variant="subheading"
                  color="primary"
                  style={{fontSize: '1vw', textTransform: 'none'}}
                >
                  {name}
                </Typography>
                  <ArrowDropDown color="primary"/>
              </Button>

              <Popover
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                onClose={() => {this.setState({open: false})}}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                PaperProps={{
                  style: styles.popover.paper,
                }}
              >
                <List dense={true}>

                  { this.renderMenuItems(
                      accountMenuItems, 
                      appConstants.messages.ACCOUNT_LABEL
                    )
                  }
                  
                  { this.renderMenuItems(
                      administrationMenuItems, 
                      appConstants.messages.ADMINISTRATION_LABEL
                    )
                  }

                  { this.renderAlertsItems(alertsMenuItems) }

                </List>
              </Popover>
            </Grid>
          </Grid>

          <Grid item md={8} xs={12}
            style={styles.tabs}
          >
            <Tabs
              value={this.state.selectedPage}
              onChange={(e, value) => this.handlePageChange(e, value, tabsOptions)}
              textColor="primary"
              indicatorColor="primary"
              fullWidth={true}
            >
              {
                tabsOptions
                  .filter(({show=true}) => show)
                  .map(({key, text}) =>
                    <Tab
                      key={key}
                      style={styles.tab}
                      buttonStyle={styles.tabButtonStyle}
                      label={this.props.intl.formatMessage(text)}
                      value={key}
                    />
                  )
              }
            </Tabs>

            <Popover
              open={this.state.showDownload}
              anchorEl={this.state.anchorElDownload}
              onClose={() => this.setState({showDownload: false})}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <List>
                <BrowserRouter>
                  { docsMenuItems.map(({link, title}) => 
                    <Link
                      key={title.id}
                      to={link}
                      target="_blank"
                      style={styles.link}
                    >
                      <ListItem button>
                        <ListItemText
                          primary={
                            <Typography>
                              {this.props.intl.formatMessage(title)}
                            </Typography>
                          }
                        />
                      </ListItem>
                    </Link>
                  )}
                </BrowserRouter>
              </List>
            </Popover>

          </Grid>
        </Grid>

        { this.props.children }

        <Snackbar
          open={!!this.props.notification}
          message={
            <div style={styles.snackbar.message}>
              {R.path(['text'], this.props.notification)}
            </div>
          }
          autoHideDuration={10000}
          onRequestClose={this.props.actions.cancelNotification}
          bodyStyle={styles.snackbar.body}
          contentStyle={{
            color: NOTIF_COLORS[R.path(['type'], this.props.notification)] || white,
            ...styles.snackbar.content,
          }}
        />
      </React.Fragment>
    )
  }
}

const styles = {
  tab: {
    height: '100%',
    color: '#235585',
  },
  tabButtonStyle: {
    height: '100%',
  },
  link: {
    textDecoration: 'none'
  },
  chip: {
    backgroundColor: red[500],
    color: 'white',
    width: 30,
    height: 30
  },
  maintenance: {
    lineHeight: '1.5',
    flex: '3 0 1',
    color: deepOrange500,
    backgroundColor: 'white',
    border: '1px solid darkgrey',
    padding: '5px 15px 5px 5px',
    display: 'flex',
    gap: 5,
    alignItems: 'center',
  },
  contact: {
    lineHeight: '1.5',
    padding: '5px 15px 5px 5px',
    overflow: 'hidden',
  },
  icon: {
    color: deepOrange500,
    margin: '5px 5px 5px 5px',
  },
  tabs: {
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
  popover: {
    paper: {
      width: '20%',
      maxHeight: '60%',
    },
  },
  snackbar: {
    style: {
      textAlign: 'left'
    },
    body: {
      background: '#fff',
      borderTop: '1px solid #dedede',
      borderLeft: '1px solid #dedede',
      borderRight: '1px solid #dedede',
      whiteSpace: 'pre-line' ,
      height: 'auto',
      padding: 10,
      lineHeight: 1,
    },
    content: {
      fontSize: 16,
      fontWeight: 400,
      textAlign: 'center'
    }
  }
}

const mapStateToProps = (state) => ({
  notification: state.Header.notification,
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
})

export default withRouter(connect(mapStateToProps, mapActionsToProps)(injectIntl(Header)))



// WEBPACK FOOTER //
// ./src/components/common/Header.js